import React from "react";
import {Box, Dialog, IconButton, Skeleton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ChatImage = ({src, alt, size = 80}) => {
    const [loaded, setLoaded] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Box
                sx={{
                    width: size,
                    height: size,
                    borderRadius: 1,
                    overflow: "hidden",
                    position: "relative",
                    cursor: "pointer",
                    border: '1px solid #e0e0e0',
                    bgcolor: '#fafafa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                onClick={handleOpen}
            >
                {!loaded && (
                    <Skeleton
                        variant="rectangular"
                        width={size}
                        height={size}
                        sx={{
                            borderRadius: 1,
                            display: "block",
                        }}
                    />
                )}
                <img
                    src={src}
                    alt={alt}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: "cover",
                        display: loaded ? "block" : "none",
                    }}
                    onLoad={() => setLoaded(true)}
                />
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        background: "transparent",
                        boxShadow: "none",
                        overflow: "hidden",
                    },
                }}
            >
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                        zIndex: 1,
                    }}
                >
                    <CloseIcon/>
                </IconButton>

                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <img
                        src={src}
                        alt={alt}
                        style={{
                            width: "100%",   // ограничение по ширине окна
                            maxHeight: "90vh",  // ограничение по высоте окна
                            objectFit: "contain",
                            borderRadius: 8,
                        }}
                    />
                </Box>
            </Dialog>
        </>
    );
};

export default ChatImage;
